import { render, staticRenderFns } from "./WelfareActiviteRules.vue?vue&type=template&id=712b3bed&scoped=true"
import script from "./WelfareActiviteRules.vue?vue&type=script&lang=js"
export * from "./WelfareActiviteRules.vue?vue&type=script&lang=js"
import style0 from "./WelfareActiviteRules.vue?vue&type=style&index=0&id=712b3bed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b3bed",
  null
  
)

export default component.exports